module.exports = __webpack_public_path__ + "media/img/img-mission-ashida-abf672aa.png";